import APIAmplify from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getListAdminOfCorporation } from '@/service/userService';
import organizationService from '@/service/organizationService';
import { I18n } from 'aws-amplify';
import { getUserById } from '@/service/userService';
import { cloneDeep } from 'lodash';
import { getProjectById } from '@/service/projectService';

export const handleChangeContractType = (event, argsAll) => {
    argsAll.setContractType(event.target.value);
};

export const handleChangeStatusOrg = (event, argsAll) => {
    argsAll.setStatusOrg(`${event.target.value}`);
};

export const isDisableBtnSubmit = argsAll => {
    if(!Utils.isEmptyObject(argsAll.selectedPersonInCharge) && argsAll.selectedPersonInCharge?.id === null) {
        return false;
    }
    
    return Utils.isEmptyObject(argsAll.errors) && argsAll.isEdited && !argsAll.errorStorage;
};

export const getListUserInCorporation = async (argsAll, organizationData) => {
    argsAll.setIsLoading(true);
    let listPersonInCharge = [];   
    const ownerIdCurrent = organizationData.owner;

    let userList = await getListAdminOfCorporation(APIAmplify, argsAll.orgId);
    if(!userList) {
        return argsAll.enqueueSnackbar('error', {
            variant: 'error',
            autoHideDuration: 3000
        });
    }

    if(userList) {
        let userNewList = userList.filter(
            user =>
                ![Constant.ACTIVE_FLAG.DELETED, Constant.ACTIVE_FLAG.INACTIVE].includes(
                    user.active
                )
        );

        listPersonInCharge = userNewList.map(user => {
            return {
                label: Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, user),
                id: user.id,
                active: user.active,
                privilege: user.privilege,
                mail: Utils.getDisplayUserEmailWithoutSuffix(user.mail)
            };
        });

        let currentOwnerInfo = await getUserById(APIAmplify, ownerIdCurrent);
        if (
            ![Constant.PRIVILEGE_USER.ADMIN, Constant.PRIVILEGE_USER.ADMIN_OWNER].includes(
                currentOwnerInfo.privilege
            )
        ) {
            listPersonInCharge.push({
                label: Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, currentOwnerInfo),
                id: currentOwnerInfo.id,
                active: currentOwnerInfo.active,
                privilege: currentOwnerInfo.privilege,
                mail: Utils.getDisplayUserEmailWithoutSuffix(currentOwnerInfo.mail)
            });
        }

        listPersonInCharge = Utils.sortListByLabelDictionaryASC(listPersonInCharge);

        currentOwnerInfo = listPersonInCharge.filter(user => user.id === ownerIdCurrent);
        if (!Utils.isEmptyArray(currentOwnerInfo)) {
            argsAll.setSelectedPersonInCharge(currentOwnerInfo[0]);
            argsAll.setMailAddress(Utils.getDisplayUserEmailWithoutSuffix(currentOwnerInfo[0].mail));
            argsAll.setAutoCompleteUserList(listPersonInCharge);
            argsAll.setIsLoading(false);
        }
    }
};

export const onChangeSelectedPersonInCharge = (_, value, argsAll) => {
    argsAll.setSelectedPersonInCharge(value);
    argsAll.setMailAddress(Utils.getDisplayUserEmailWithoutSuffix(value.mail));
    argsAll.setIsEdited(true);
};

export const updateTabNameAfterEditCorporation = (panelList, setPanelList, newOutline, panelId, corpId) => {
    let currentPanelList = cloneDeep(panelList);
    if (Utils.isEmptyArray(currentPanelList)) return;
    let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
    if (currentPanelIndex === -1) return;

    let currentPanel = currentPanelList[currentPanelIndex];

    if (Utils.isEmptyArray(currentPanel.tabList)) return;
    let currentTabIndex = Utils.findIndexInArrayById(corpId, currentPanel.tabList);
    if (currentTabIndex === -1) return;

    // Update corp outline
    currentPanelList[currentPanelIndex].tabList[currentTabIndex].orgName = newOutline;
    setPanelList([...currentPanelList]);
};

export const reloadPage = argsAll => {
    argsAll.setTriggerReload(Date.now().toString());
};

export const resetOrgDetailData = (argsAll, formData) => {
    argsAll.setIsEdited(false);
        argsAll.reset(formData);
}

export const onSubmitEditOrg = async argsAll => {
    let formData = argsAll.getValues();
    const limitValue =  {
        maxNumOfGeneralUser: argsAll.maxGeneral,
        maxNumOfTicket: argsAll.maxTicket,
        maxNumOfStorage: argsAll.maxStorage
    };
    const requestDto = {
        id: argsAll.orgId,
        active: argsAll.statusOrg,
        name: formData.corporationName,
        contractType: argsAll.contractType,
        tel: formData.telNumberCorporation,
        mail: argsAll.mailAddress,
        owner: argsAll.selectedPersonInCharge?.id,
        updator: argsAll.userDetail.id,
        limitValue: JSON.stringify(limitValue),
        warningMaxTicket: argsAll.warningMaxTicket,
        warningMaxStorage: argsAll.warningMaxStorage,
        updateMethod: Constant.UPDATE_CORP_DETAIL_METHOD.UPDATE_DETAIL
    };
    argsAll.setIsShowDialogSubmit(false);
    argsAll.setIsLoading(true);

    let result = await organizationService.editCorporations(APIAmplify, requestDto);
    if (result) {

        if (!result.updateStatus && result.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            argsAll.setIsShowReload(true);
            return;
        }

        let newCorporationDetail = await organizationService.getCorporationById(
            APIAmplify,
            result.id
        );

        if(!result.updateStatus) {
            const errorList = result?.errorList[0];
            newCorporationDetail.name = Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP, newCorporationDetail);
            argsAll.setOrganizationDetail(newCorporationDetail);
            if (!Utils.isEmptyString(errorList.maxNumOfGeneralUser)) {
                argsAll.setError(
                    Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_GENERAL_USER,
                    {
                        type: 'focus',
                        message: I18n.get(errorList.maxNumOfGeneralUser).replace(
                            '{{current_genneral_number}}',
                            `${newCorporationDetail.limitValue.numOfGeneralUser}`
                        )
                    },
                    { shouldFocus: true }
                );
            }
            if (!Utils.isEmptyString(errorList.maxNumOfTicket)) {
                switch (errorList.maxNumOfTicket) {
                    case 'COMMSG012':
                        argsAll.setError(
                            Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET,
                            {
                                type: 'focus',
                                message: I18n.get(errorList.maxNumOfTicket).replace(
                                    '{{Y}}',
                                    Constant.LIMIT_VALUE_SETTING.MAX_NUM_OF_TICKET
                                )
                            },
                            { shouldFocus: true }
                        );
                        break;
                    case 'USER14MSG017':
                        argsAll.setError(
                            Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET,
                            {
                                type: 'focus',
                                message: I18n.get(errorList.maxNumOfTicket).replace(
                                    '{{current_ticket_number}}',
                                    `${newCorporationDetail.limitValue.numOfTicket}`
                                )
                            },
                            { shouldFocus: true }
                        );
                        break;
                    default:
                        break;
                }
            }
            if (!Utils.isEmptyString(errorList.maxNumOfStorage)) {
                switch (errorList.maxNumOfStorage) {
                    case 'COMMSG012':
                        argsAll.setErrorStorage(
                            I18n.get(errorList.maxNumOfStorage).replace(
                                '{{Y}}',
                                Constant.LIMIT_VALUE_SETTING.MAX_NUM_OF_STORAGE
                            )
                        );
                        break;
                    case 'USER14MSG018':
                        argsAll.setErrorStorage(
                            I18n.get(errorList.maxNumOfStorage).replace(
                                '{{current_storage}}',
                                `${Utils.convertByteToGigaByte(newCorporationDetail.limitValue.numOfStorage, 6)}`
                            )
                        );
                        break;
                    default:
                        break;
                }
            }
            return argsAll.setIsLoading(false);
        }

        let outline = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, newCorporationDetail.name);
        argsAll.reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
        updateTabNameAfterEditCorporation(
            argsAll,
            outline,
            argsAll.panelId,
            newCorporationDetail.id
        );
        reloadPage(argsAll);
        resetOrgDetailData(argsAll, formData);
        checkWarningSetting(argsAll, newCorporationDetail);
        argsAll.setIsLoading(false);
        return argsAll.enqueueSnackbar(I18n.get('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    }
    return argsAll.setIsLoading(false);
};

export const onConfirmCancelDialog = argsAll => {
    argsAll.setIsShowDialogCancel(false);
    argsAll.setIsEdited(false);
    argsAll.setErrorStorage('');
    let formData = argsAll.getValues();
    argsAll.reset(formData);
    argsAll.setTriggerReload(Date.now().toString());
};

export const onCancelDialog = (isDirty, isEdited, setIsShowDialogCancel) => {
    if (isDirty || isEdited) {
        setIsShowDialogCancel(true);
    }
};

export const onSubmitDialog = argsAll => {
    argsAll.setIsShowDialogSubmit(true);
};

export const handleChangePermissionService = (e, argsAll) => {
    switch (e.target.id) {
        case I18n.get('USER14LB010'):
            argsAll.setDeskService(prev => ({
                ...prev,
                isOpenModal: true,
                temporaryChecked: e.target.checked
            }));
            break;
        case I18n.get('USER14LB011'):
            argsAll.setKnowledgeService(prev => ({
                ...prev,
                isOpenModal: true,
                temporaryChecked: e.target.checked
            }));
            break;
        case I18n.get('USER14LB012'):
            argsAll.setTaskManagementService(prev => ({
                ...prev,
                isOpenModal: true,
                temporaryChecked: e.target.checked
            }));
            break;
        case I18n.get('USER14LB013'):
            argsAll.setPublicService(prev => ({
                ...prev,
                isOpenModal: true,
                temporaryChecked: e.target.checked
            }));
            break;
        default:
            break;
    }
};

export const submitStatusService = async (
    setIsLoading,
    rootCorporationInfo,
    stateService,
    userDetail,
    setOpenPopupConfirm,
    API,
    reloadTicketListByPanelType,
    panelList,
    setPanelList,
    panelId,
    setTriggerReload,
    enqueueSnackbar
) => {
    const method = stateService.method;
    setIsLoading(true);

    const requestDto = {
        id: rootCorporationInfo.id,
        statusService: stateService.checked
            ? Constant.STATUS_SERVICE_PERMISSION.ON
            : Constant.STATUS_SERVICE_PERMISSION.OFF,
        updator: userDetail.id,
        updateMethod: method
    };

    setOpenPopupConfirm({ isOpen: false });

    let result = await organizationService.updatePermissionCorp(APIAmplify, requestDto);

    if (result) {
        let newCorporationDetail = await organizationService.getCorporationById(APIAmplify, result.id);
        let outline = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, newCorporationDetail.name);
        
        reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
        updateTabNameAfterEditCorporation(
            panelList,
            setPanelList,
            outline,
            panelId,
            newCorporationDetail.id
        );
        setTriggerReload(Date.now().toString());
        enqueueSnackbar(I18n.get('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    } else {
        setIsLoading(false);
    }
};

export const onKeyDown = (event, invalidCharArr) => {
    if(Utils.isEmptyArray(invalidCharArr)) {
        return;
    }
    if (invalidCharArr.includes(event.key)) {
        event.preventDefault();
    }
};

export const handleOnPaste =(event, invalidCharArr) => {
    if(Utils.isEmptyArray(invalidCharArr)) {
        return;
    }
    const value = event.clipboardData.getData('text');
    invalidCharArr?.forEach(item => {if(value.includes(item)){
        event.preventDefault();
    }})
}

export const handleOnchangeLimitValue = (event, argsAll, nameField) => {
    argsAll.setIsEdited(true);

    let value = event.target.value;    
    if (value.length === 0) {
        argsAll.setError(
            nameField,
            { type: 'manual', message: I18n.get('COMMSG014') },
            { shouldFocus: false }
        );
    } else {
        argsAll.clearErrors(nameField);
    }

    switch(nameField) {
        case Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_GENERAL_USER:
            if (/^0/.test(value)) {
                value = value.toString().slice(0, 3).replace(/^0/, '')
                if (value.length === 0) {
                    argsAll.setError(
                        nameField,
                        { type: 'manual', message: I18n.get('COMMSG014') },
                        { shouldFocus: false }
                    );
                }
                return argsAll.setMaxGeneral(value);
            }
            argsAll.setMaxGeneral(
                value
                    .toString()
                    .slice(0, 3)
                    .replace(/[^0-9]/g, '')
            );
            break;
        case Constant.LIMIT_VALUE_NAME.MAX_NUM_OF_TICKET:
            if (/^0/.test(value)) {
                value = value.toString().slice(0, 8).replace(/^0/, '')
                if (value.length === 0) {
                    argsAll.setError(
                        nameField,
                        { type: 'manual', message: I18n.get('COMMSG014') },
                        { shouldFocus: false }
                    );
                }
                return argsAll.setMaxTicket(value);
            }
            argsAll.setMaxTicket(
                value
                    .toString()
                    .slice(0, 8)
                    .replace(/[^0-9]/g, '')
            );

            argsAll.setWarningMaxTicket(false);
            break;
        default:
            break;
    }

};

export const onChangeSettingMaxStorage = (e, argsAll) => {
    let value = e.target.value;
    if(Utils.isEmptyString(value)) {
        argsAll.setMaxStorage(value);
        return argsAll.setErrorStorage(I18n.get('COMMSG014'));
    }
    argsAll.setWarningMaxStorage(false);
    argsAll.setIsEdited(true);
    argsAll.setErrorStorage('');
    let number = value.split('.');
    let integerPart = number[0];
    let decimalPart = number[1];

    if (value.length > 4 && !decimalPart) {
        return argsAll.setMaxStorage(value.toString().slice(0, 4));
    }

    if (decimalPart) {
        return argsAll.setMaxStorage(
            `${integerPart
                .toString()
                .slice(0, 4)}.${decimalPart
                .toString()
                .slice(0, 3)}`
        );
    } else {
        argsAll.setMaxStorage(value);
    }
};

export const disableScrollTypeNumberInput = (e) => {
    e.target.blur();
}

export const getListB2BCutomer = async (argsAll, listProjectB2BCustomer) => {
    listProjectB2BCustomer = listProjectB2BCustomer.filter(
        (value, index, self) => index === self.findIndex(t => t.id2 === value.id2)
    );
    let promise = [];
    for(let item of listProjectB2BCustomer) {
        promise.push(getItemB2BCustomerInfo(argsAll, item));
    }
    await Promise.all(promise);
};

export const getItemB2BCustomerInfo = async (argsAll, item) => {
    let projectInfo = await getProjectById(APIAmplify, item.id2);
    if (!Utils.isEmptyObject(projectInfo)) {
        let corpInfo = await organizationService.getCorporationById(
            APIAmplify,
            projectInfo.affiliationOrganization
        );
        if (!Utils.isEmptyObject(corpInfo)) {
            let projectName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                projectInfo.name
            )
            let corporationName = Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP, corpInfo);
            argsAll.setListB2BCustomer(prev => [
                ...prev,
                { name: `${projectName} (${corporationName})`, corporationName: corporationName }
            ]);
        }
    }
};

export const isShowContractDate = (organizationDetail) => {
    return [Constant.CORPORATION_ACTIVE.ACTIVE, Constant.CORPORATION_ACTIVE.BLOCK].includes(organizationDetail.active);
}

export const isDisplayWarningIcon = (organizationDetail) => {
    const limitValue = organizationDetail.limitValue;
    return (
        limitValue?.numOfTicket > limitValue?.maxNumOfTicket ||
        limitValue?.numOfStorage > limitValue?.maxNumOfStorage ||
        limitValue?.numOfB2CCustomer > limitValue?.maxNumOfB2CCustomer ||
        limitValue?.numOfTicketKnowledge > limitValue?.maxNumOfTicketKnowledge ||
        limitValue?.numOfInternalUser > limitValue?.maxNumOfInternalUser ||
        limitValue?.numOfGeneralProject > limitValue?.maxNumOfGeneralProject
    );
}

export const checkWarningSetting = (args, organizationData) => {
    if(organizationData.limitValue?.maxNumOfTicket < organizationData.limitValue?.numOfTicket) {
        args.setWarningMaxTicket(true);
    } else {
        args.setWarningMaxTicket(false);
    }

    if (
        Utils.convertByteToGigaByte(organizationData.limitValue?.maxNumOfStorage, 6) <
        Utils.convertByteToGigaByte(organizationData.limitValue?.numOfStorage, 6)
    ) {
        args.setWarningMaxStorage(true);
    } else {
        args.setWarningMaxStorage(false);
    }
}

export const getUrlLinkCorporationDetails = (organizationDetail) => {
    if(Utils.isEmptyObject(organizationDetail)) return;
    let url = `${window.location.origin}/${organizationDetail.organizationDomain}`;
    switch (organizationDetail.contractType) {
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK:
            url = `${window.location.origin}/${organizationDetail.inviterOrganizationDomain}/p/${organizationDetail.organizationDomain}`
            break;
        case Constant.CORPORATION_CONTRACT_TYPE.GUEST:
            url = `${window.location.origin}/${organizationDetail.inviterOrganizationDomain}/c/${organizationDetail.organizationDomain}`
            break;
        default:
            url = `${window.location.origin}/${organizationDetail.organizationDomain}`;
            break;
    }
    return url;
}


/**
 * isDisableBtnSubmitEditBasicInfo
 * @param {*} selectedPersonInCharge 
 * @param {*} isEdited 
 * @param {*} errors 
 * @returns 
 */
export const isDisableBtnSubmitEditBasicInfo = (selectedPersonInCharge, isEdited, errors) => {
    if(Utils.isEmptyObject(selectedPersonInCharge) || !selectedPersonInCharge?.id) {
        return false;
    }
    
    return Utils.isEmptyObject(errors) && isEdited;
};


/**
 * initCorporationContractDetail
 * @param {*} corporationId 
 * @returns 
 */
export const initCorporationContractDetail = async (API, corporationId, affiliationOrganization) => {
    if (!corporationId) return;

    let paramsData = {
        method: Constant.GET_CORPORATION_CONTRACT_DETAIL_METHOD.GET_CORPORATION_AND_CONTRACT_DATA,
        corporationId: corporationId,
        affiliationOrganization: affiliationOrganization
    }

    let res = await organizationService.getCorporationAndContractDetail(APIAmplify, paramsData);
    if (!res) return;
    if (!res.status) return;

    return Utils.convertJSONDataToObject(res.data);
}

/**
 * initCorporationContractDetail
 * @param {*} corporationId 
 * @returns 
 */
export const initContractDetail = async (API, corporationId) => {
    if (!corporationId) return;

    let paramsData = {
        method: Constant.GET_CORPORATION_CONTRACT_DETAIL_METHOD.GET_CORPORATION_AND_CONTRACT_DATA_TO_VIEW_AND_UPDATE,
        corporationId: corporationId
    }

    let res = await organizationService.getCorporationAndContractDetail(APIAmplify, paramsData);
    if (!res) return;
    if (!res.status) return;
    return Utils.convertJSONDataToObject(res.data);
}

/**
 * initCorporationContractDetail
 * @param {*} corporationId 
 * @returns 
 */
export const initCorporationAndListUser = async (corporationId) => {
    if (!corporationId) return;

    let paramsData = {
        method: Constant.GET_CORPORATION_CONTRACT_DETAIL_METHOD.GET_CORPORATION_LIST_USER,
        corporationId: corporationId
    }

    let res = await organizationService.getCorporationAndContractDetail(APIAmplify, paramsData);
    if (!res) return;
    if (!res.status) return;

    return Utils.convertJSONDataToObject(res.data);
}


/**
 * getOrgStatus
 * @param {*} org 
 * @returns 
 */
export const getOrgStatus = org => {
    if (org?.active === Constant.CORPORATION_ACTIVE.ACTIVE) {
        return Constant.STATUS_OF_ORG.ACTIVE;
    }
    if (org?.active === Constant.CORPORATION_ACTIVE.REJECT) {
        return Constant.STATUS_OF_ORG.REJECT;
    }
    if (org?.active === Constant.CORPORATION_ACTIVE.BLOCK) {
        return Constant.STATUS_OF_ORG.BLOCK;
    }
    return Constant.STATUS_OF_ORG.WAITING;
};


/**
 * onSubmitEditOrgBasicInfo
 * @param {*} corporationId 
 * @param {*} getValues 
 * @param {*} setIsShowDialogSubmit 
 * @param {*} setIsLoading 
 * @param {*} enqueueSnackbar 
 * @param {*} reloadTicketListByPanelType 
 * @param {*} panelList 
 * @param {*} setPanelList 
 * @param {*} panelId 
 * @param {*} setTriggerReload 
 * @param {*} ownerId 
 * @param {*} updator 
 * @returns 
 */
export const onSubmitEditOrgBasicInfo = async (
    API,
    corporationId,
    getValues,
    setIsShowDialogSubmit,
    setIsLoading,
    enqueueSnackbar,
    reloadTicketListByPanelType,
    panelList,
    setPanelList,
    panelId,
    setTriggerReload,
    ownerId,
    updator,
    setIsShowDialogCancel,
    reset,
    setIsEdited,
    setIsShowReload
) => {
    if (!corporationId) return;

    let formData = getValues();
    const requestDto = {
        id: corporationId,
        name: formData.corporationName,
        tel: formData.telNumberCorporation,
        owner: ownerId,
        updator: updator,
        updateMethod: Constant.UPDATE_CORP_DETAIL_METHOD.UPDATE_BASIC_INFO
    };

    setIsShowDialogSubmit(false);
    setIsShowDialogCancel(false);
    setIsLoading(true);
    
    let result = await organizationService.editCorporations(APIAmplify, requestDto);
    if (result) {
        if (!result.updateStatus && result.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            setIsShowReload(true);
            return;
        }

        reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
        updateTabNameAfterEditCorporation(
            panelList,
            setPanelList,
            formData.corporationName,
            panelId,
            corporationId
        );
        setIsEdited(false);
        reset(formData);
        setIsLoading(false);
        setTriggerReload(Date.now().toString());
        return enqueueSnackbar(I18n.get('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    }

    return setIsLoading(false);
};


/**
 * onChangeCorporationOwner
 * @param {*} value 
 * @param {*} setIsEdited 
 * @param {*} setSelectedPersonInCharge 
 */
export const onChangeCorporationOwner = (value, setIsEdited, setSelectedPersonInCharge) => {
    setSelectedPersonInCharge(value);
    setIsEdited(true);
}

/**
 * onChangeVersion
 * @param {*} value 
 * @param {*} setSelectedVersion 
 */
export const onChangeVersion = (value, setSelectedVersion, setIsEdit, listVersion) => {
    const valueData = listVersion.find(item => item.label === value);
    setSelectedVersion(valueData);
    setIsEdit(true);
}

export const getInitDataViewDetailContract = contractDetail => {
    if (
        Utils.isEmptyObject(contractDetail?.productData) ||
        Utils.isEmptyObject(contractDetail?.editionData) ||
        Utils.isEmptyObject(contractDetail?.versionData)
    )
        return {};

    const additionalPrivateSetting = contractDetail?.contractDetail?.additionalPrivateSetting
        ? contractDetail?.contractDetail?.additionalPrivateSetting
        : {};

    let dataListVersion = [...contractDetail.versionList];
    let listVersion = [];
    dataListVersion.forEach(item => {
        const labelVersion = Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            item?.name
        );
        item.label = labelVersion;

        listVersion.push(item);
    })
    listVersion = Utils.sortByCreatedAtDesc(listVersion);

    let nameProduct = Utils.getTextByLanguage(
        Constant.LANGUAGE_TYPE.JP,
        contractDetail?.productData?.name
    );
    let productData = { ...contractDetail?.productData };
    productData.label = nameProduct;

    let nameEdition = Utils.getTextByLanguage(
        Constant.LANGUAGE_TYPE.JP,
        contractDetail?.editionData?.name
    );
    let editionData = { ...contractDetail?.editionData };
    editionData.label = nameEdition;

    let nameVersion = Utils.getTextByLanguage(
        Constant.LANGUAGE_TYPE.JP,
        contractDetail?.versionData?.name
    );
    let versionData = { ...contractDetail?.versionData };
    versionData.label = nameVersion;

    let corporationData = { ...contractDetail?.corporationData };

    const limitValue = corporationData.limitValue;
    const moduleSetting = versionData.moduleSetting;
    const limitValueContract = contractDetail?.contractDetail?.limitValue;

    let maxGeneralUser = limitValue.maxNumOfGeneralUser;
    let numOfUserUnassigned = Number(maxGeneralUser) - (Number(limitValue.numOfGeneralUser) || 0);
    let numOfUserInOrg = Number(limitValue.numOfGeneralUser) - (Number(limitValue.numOfPartnerId) || 0);

    let usedStorage = Utils.convertByteToGigaByte(limitValue.numOfStorage, 6) || 0;
    usedStorage = parseFloat(Number(usedStorage).toFixed(3));

    const listResources = [
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_GENERAL_ID_NUMBER,
            unit: 'ID',
            value: maxGeneralUser,
            listItems: [
                {
                    label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_INTERNAL_ID,
                    value: numOfUserInOrg || 0,
                    unit: I18n.get('LABEL-ID')
                },
                {
                    label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_PARTNER_ID,
                    value: limitValue.numOfPartnerId || 0,
                    unit: I18n.get('LABEL-ID')
                },
                {
                    label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_UNASSIGNED_ID,
                    value: numOfUserUnassigned,
                    unit: 'ID'
                }
            ]
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_INTERNAL_CUSTOMER_ID_NUMBER,
            listItems: [],
            unit: 'ID',
            value: limitValue.numOfInternalUser,
            maxValue: limitValueContract?.maxNumOfInternalUser || 0,
            isOverMax: limitValue.numOfInternalUser - (limitValueContract?.maxNumOfInternalUser || 0) > 0
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_B2C_ID_NUMBER,
            listItems: [],
            unit: 'ID',
            value: limitValue.numOfB2CCustomer,
            maxValue: limitValueContract?.maxNumOfB2CCustomer || 0,
            isOverMax: limitValue.numOfB2CCustomer - (limitValueContract?.maxNumOfB2CCustomer || 0) > 0
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_PROJECT_NUMBER,
            maxValue: limitValueContract?.maxNumOfGeneralProject || 0,
            value: limitValue.numOfGeneralProject,
            isOverMax: limitValue.numOfGeneralProject - (limitValueContract?.maxNumOfGeneralProject || 0) > 0,
            unit: '個',
            listItems: [
                {
                    label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_GENERAL_PROJECT_NUMBER,
                    value: parseInt(limitValue.numOfGeneralProject) - parseInt(limitValue.numOfProjectDeskOn) || 0,
                    unit: '個'
                },
                {
                    label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_INTERNAL_DESK_NUMBER,
                    value:  parseInt(limitValue.numOfProjectDeskOn) - parseInt(limitValue.numOfProjectPublicOn) || 0,
                    unit: '個'
                },
                {
                    label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_PUBLIC_DESK_NUMBER,
                    value: parseInt(limitValue.numOfProjectPublicOn) || 0,
                    unit: '個'
                }
            ]
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_QA_COUNTER_NUMBER,
            listItems: [],
            unit: I18n.get('LABEL-NUMBER'),
            value: limitValue.numOfGuestDesk,
            maxValue: limitValue?.maxNumOfGuestDesk || 0,
            isOverMax: limitValue.numOfGuestDesk - (limitValue?.maxNumOfGuestDesk || 0) > 0
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_SUPPORT_COUNTER_NUMBER,
            listItems: [],
            unit: I18n.get('LABEL-NUMBER'),
            value: limitValue.numOfGuestProject,
            maxValue: limitValue?.maxNumOfGuestProject || 0,
            isOverMax: limitValue.numOfGuestProject - (limitValue?.maxNumOfGuestProject || 0) > 0
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_QA_TICKET_NUMBER,
            listItems: [],
            unit: '個',
            value: limitValue.numOfTicket,
            maxValue: limitValueContract?.maxNumOfTicket || 0,
            isOverMax: limitValue.numOfTicket - (limitValueContract?.maxNumOfTicket || 0) > 0
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_KNOWLEDGE_TICKET_NUMBER,
            listItems: [],
            unit: '個',
            value: limitValue.numOfTicketKnowledge,
            maxValue: limitValueContract?.maxNumOfTicketKnowledge || 0,
            isOverMax: limitValue.numOfTicketKnowledge - (limitValueContract?.maxNumOfTicketKnowledge || 0) > 0
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_STORAGE_USAGE_NUMBER,
            listItems: [],
            unit: 'GB',
            value: usedStorage,
            maxValue: parseFloat((Number(Utils.convertByteToGigaByte(limitValueContract?.maxNumOfStorage, 6))).toFixed(3)) || 0,
            isOverMax: usedStorage - parseFloat((Number(Utils.convertByteToGigaByte(limitValueContract?.maxNumOfStorage, 6))).toFixed(3)) > 0
        },
        {
            label: Constant.ROOT_CORPORATION.RESOURCE_LIST.LABEL_EXTERNAL_WEB_API_CALLS_NUMBER,
            listItems: [],
            unit: I18n.get('LABEL-CALLS'),
            value: limitValue?.numOfExternalAPICalls || 0,
            maxValue: parseInt((Number(limitValueContract?.maxNumberOfExternalAPICalls || 0))) || 0,
            isOverMax: limitValue?.numOfExternalAPICalls - parseInt((Number(limitValueContract?.maxNumberOfExternalAPICalls || 0))) > 0
        }
    ];

    const listOptionUsages = [
        {
            id: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_NUMBER_OF_TICKET,
            label: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_NUMBER_OF_TICKET,
            unit: I18n.get('LABEL-UNIT-SET'),
            value: 0
        },
        {
            id: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_NUMBER_OF_KNOWLEDGE,
            label: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_NUMBER_OF_KNOWLEDGE,
            unit: I18n.get('LABEL-UNIT-SET'),
            value: 0
        },
        {
            id: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_STORAGE,
            label: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_STORAGE,
            unit: I18n.get('LABEL-UNIT-SET'),
            value: 0
        },
        {
            id: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_NUMBER_OF_QA_COUNTER,
            label: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_NUMBER_OF_QA_COUNTER,
            unit: I18n.get('LABEL-UNIT-SET'),
            value: 0
        },
        {
            id: Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_NUMBER_OF_SUPPORTED_COUNTER,
            label:
                Constant.ROOT_CORPORATION.OPTION_USAGE.LABEL_ADVANCED_NUMBER_OF_SUPPORTED_COUNTER,
            unit: I18n.get('LABEL-UNIT-SET'),
            value:0
        }
    ];

    let listProvideFunction = [
        {
            label:
                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                    .LABEL_FUNCTION_PUBLIC_SERVICE_DESK_SETTINGS,
            switchVersion: moduleSetting.deskService,
            switchCorporation: corporationData.deskService,
            switchCorporationDefault: corporationData.deskService,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('deskService')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_PUBLIC_WEB_FORM,
            switchVersion: moduleSetting.publicWebForm,
            switchCorporation: limitValue.publicWebForm,
            switchCorporationDefault: limitValue.publicWebForm,
            switchCorpDisabled: !corporationData.deskService,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('publicWebForm')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_EMAIL_RESPONSE_FUNCTION,
            switchVersion: moduleSetting.emailResponseFunction,
            switchCorporation: limitValue.emailResponseFunction,
            switchCorporationDefault: limitValue.emailResponseFunction,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('emailResponseFunction')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_SOLUTIONDESK_KNOWLEDGE,
            switchVersion: moduleSetting.knowledgeService,
            switchCorporation: corporationData.knowledgeService,
            switchCorporationDefault: corporationData.knowledgeService,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('knowledgeService')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_PUBLIC_KNOWLEDGE_SITE,
            switchVersion: moduleSetting.publicService,
            switchCorporation: corporationData.publicService,
            switchCorporationDefault: corporationData.publicService,
            switchCorpDisabled: !corporationData.knowledgeService,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('publicService')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_KNOWLEDGE_BOT,
            switchVersion: moduleSetting.knowledgeBot,
            switchCorporation: limitValue.knowledgeBot,
            switchCorporationDefault: limitValue.knowledgeBot,
            switchCorpDisabled: !corporationData.knowledgeService,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('knowledgeBot')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CONVERT_PDF,
            switchVersion: moduleSetting.convertPDF,
            switchCorporation: limitValue?.convertPDF,
            switchCorporationDefault: limitValue?.convertPDF,
            switchCorpDisabled: !corporationData.knowledgeService,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('convertPDF')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_SYNONYM_SEARCH,
            switchVersion: moduleSetting.synonymSearch,
            switchCorporation: limitValue?.synonymSearch,
            switchCorporationDefault: limitValue?.synonymSearch,
            switchCorpDisabled: !corporationData.knowledgeService,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('synonymSearch')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_BATCH_COMMAND,
            switchVersion: moduleSetting.batchCommandService,
            switchCorporation: limitValue?.batchCommandService,
            switchCorporationDefault: limitValue?.batchCommandService,
            switchCorpDisabled: !corporationData.knowledgeService,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('batchCommandService')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI,
            switchVersion: moduleSetting.chatAI,
            switchCorporation: limitValue?.chatAI,
            switchCorporationDefault: limitValue?.chatAI,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('chatAI')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION,
            switchVersion: moduleSetting.lincenseKeyPermission,
            switchCorporation: limitValue?.lincenseKeyPermission,
            switchCorporationDefault: limitValue?.lincenseKeyPermission,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('lincenseKeyPermission')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_AI_AUTO,

            switchVersion: moduleSetting.aiAuto,
            switchCorporation: limitValue?.aiAuto,
            switchCorporationDefault: limitValue?.aiAuto,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('aiAuto')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_SD_AUTO,
            switchVersion: moduleSetting?.sdAuto,
            switchCorporation: limitValue?.sdAuto,
            switchCorporationDefault: limitValue?.sdAuto,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('sdAuto')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_TELEPHONE_AGENT,
            switchVersion: moduleSetting.telephoneAgent,
            switchCorporation: limitValue?.telephoneAgent,
            switchCorporationDefault: limitValue?.telephoneAgent,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('telephoneAgent')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_MCP_SERVER,
            switchVersion: moduleSetting?.mcpServer,
            switchCorporation: limitValue?.mcpServer,
            switchCorporationDefault: limitValue?.mcpServer,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('mcpServer')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_ADVANCED_SETTINGS,
            switchVersion: moduleSetting.advancedOptionSettings,
            switchCorporation: limitValue.advancedOptionSettings,
            switchCorporationDefault: limitValue.advancedOptionSettings,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('advancedOptionSettings')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LOG_ANALYSIS,
            switchVersion: moduleSetting.logAnalysis,
            switchCorporation: limitValue.logAnalysis,
            switchCorporationDefault: limitValue.logAnalysis,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('logAnalysis')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_IP_RESTRICTION,
            switchVersion: moduleSetting?.ipRestriction,
            switchCorporation: limitValue?.ipRestriction,
            switchCorporationDefault: limitValue?.ipRestriction,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('ipRestriction')
        },
        {
            label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_MULTI_AUTH,
            switchVersion: moduleSetting?.multiAuth,
            switchCorporation: limitValue?.multiAuth,
            switchCorporationDefault: limitValue?.multiAuth,
            switchCorpDisabled: false,
            usedToCustomize: additionalPrivateSetting.hasOwnProperty('multiAuth')
        }
    ];

    // comment for now
    // const optionsExternalAPI =
    //     {
    //         label: Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_EXTERNAL_WEB_API,
    //         switchVersion: moduleSetting?.externalWebAPI,
    //         switchCorporation: limitValue?.externalWebAPI,
    //         switchCorporationDefault: limitValue?.externalWebAPI,
    //         switchCorpDisabled: !moduleSetting?.externalWebAPI,
    //         usedToCustomize: additionalPrivateSetting.hasOwnProperty('externalWebAPI')
    //     },

    const listInvidualBasicSettings = [
        {
            label: Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_NUMBER_OF_TICKET,
            unit: I18n.get('LABEL-UNIT-TICKET-PER-PERSON'),
            value: !Utils.isEmpty(additionalPrivateSetting?.numOfTicket) ? additionalPrivateSetting?.numOfTicket : '',
            oldValue: !Utils.isEmpty(additionalPrivateSetting?.numOfTicket) ? additionalPrivateSetting?.numOfTicket : '',
            disabled: false,
            error: ''
        },
        {
            label: Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_NUMBER_OF_KNOWLEDGE,
            unit: I18n.get('LABEL-UNIT-TICKET-PER-PERSON'),
            value: !Utils.isEmpty(additionalPrivateSetting?.numberOfKnowledges) ? additionalPrivateSetting?.numberOfKnowledges : '',
            oldValue: !Utils.isEmpty(additionalPrivateSetting?.numberOfKnowledges) ? additionalPrivateSetting?.numberOfKnowledges : '',
            disabled: !corporationData.knowledgeService,
            error: ''
        },
        {
            label:
                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_NUMBER_OF_QA_COUNTER,
            unit: I18n.get('LABEL-UNIT-PRJ-PER-ORG'),
            value: !Utils.isEmpty(additionalPrivateSetting?.numOfQACounters) ? additionalPrivateSetting?.numOfQACounters : '',
            oldValue: !Utils.isEmpty(additionalPrivateSetting?.numOfQACounters) ? additionalPrivateSetting?.numOfQACounters : '',
            disabled: !corporationData.deskService,
            error: ''
        },
        {
            label:
                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                    .LABEL_BASIC_NUMBER_OF_SUPPORTED_COUNTER,
            unit: I18n.get('LABEL-UNIT-PRJ-PER-ORG'),
            value: !Utils.isEmpty(additionalPrivateSetting?.numOfSupportedCounters) ? additionalPrivateSetting?.numOfSupportedCounters : '',
            oldValue: !Utils.isEmpty(additionalPrivateSetting?.numOfSupportedCounters) ? additionalPrivateSetting?.numOfSupportedCounters : '',
            disabled: !corporationData.deskService,
            error: ''
        },
        {
            label:
                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_NUMBER_OF_GENERAL_PRJ,
            unit: I18n.get('LABEL-UNIT-PRJ-PER-ORG'),
            value: !Utils.isEmpty(additionalPrivateSetting?.numOfGeneralProjects) ? additionalPrivateSetting?.numOfGeneralProjects : '',
            oldValue: !Utils.isEmpty(additionalPrivateSetting?.numOfGeneralProjects) ? additionalPrivateSetting?.numOfGeneralProjects : '',
            disabled: false,
            error: ''
        },
        {
            label:
                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                    .LABEL_BASIC_NUMBER_OF_INTERNAL_CUSTOMER,
            unit: I18n.get('LABEL-UNIT-PERSION-PER-ORG'),
            value: !Utils.isEmpty(additionalPrivateSetting?.numOfInternalCustomers) ? additionalPrivateSetting?.numOfInternalCustomers : '',
            oldValue: !Utils.isEmpty(additionalPrivateSetting?.numOfInternalCustomers) ? additionalPrivateSetting?.numOfInternalCustomers : '',
            disabled: false,
            error: ''
        },
        {
            label: Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_NUMBER_OF_B2C,
            unit: I18n.get('LABEL-UNIT-PERSION-PER-ORG'),
            value: additionalPrivateSetting?.numOfB2C ? additionalPrivateSetting?.numOfB2C : '',
            oldValue: additionalPrivateSetting?.numOfB2C ? additionalPrivateSetting?.numOfB2C : '',
            disabled: !Utils.isEmpty(corporationData.deskService),
            error: ''
        },
        {
            label: Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_STORAGE,
            unit: I18n.get('LABEL-UNIT-GB-PER-PERSON'),
            value: !Utils.isEmpty(additionalPrivateSetting?.numOfStorage) ? additionalPrivateSetting?.numOfStorage : '',
            oldValue: !Utils.isEmpty(additionalPrivateSetting?.numOfStorage) ? additionalPrivateSetting?.numOfStorage : '',
            disabled: false,
            error: ''
        },
        {
            label: Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_EXTERNAL_WEB_API,
            unit:  I18n.get('LABEL-UNIT-CALLS-PER-MONTH'),
            value: !Utils.isEmpty(additionalPrivateSetting?.numberOfExternalAPICalls) ? additionalPrivateSetting?.numberOfExternalAPICalls : '',
            oldValue: !Utils.isEmpty(additionalPrivateSetting?.numberOfExternalAPICalls) ? additionalPrivateSetting?.numberOfExternalAPICalls : '',
            disabled: false,
            error: ''
        }
    ];
    
    return {
        productData,
        editionData,
        versionData,
        listResources,
        listOptionUsages,
        listProvideFunction,
        listInvidualBasicSettings,
        listVersion
    };
};

export const isShowTabContractDetailByRootOrg = corporation => {
    if (Utils.isEmptyObject(corporation)) return false;
    return (
        [Constant.CORPORATION_ACTIVE.ACTIVE, Constant.CORPORATION_ACTIVE.BLOCK].includes(
            corporation.active
        ) &&
        [
            Constant.CORPORATION_CONTRACT_TYPE.PREMIUM,
            Constant.CORPORATION_CONTRACT_TYPE.TRIAL
        ].includes(corporation.contractType)
    );
};

function findDifferenceProvideFunction(arrayA, arrayB) {
    const difference = arrayB.filter(itemB => {
        const foundItem = arrayA.find(itemA => itemA.label === itemB.label);
        return !foundItem || foundItem.switchCorporation !== itemB.switchCorporation;
    });

    return difference;
}


export const onSubmitChangeStandardRootOrg = async (
    corporationId,
    updator,
    listProvideFunction,
    listProvideFunctionDefaults,
    selectedVersion,
    listInvidualBasic,
    setIsLoading,
    setTriggerReload,
    setIsShowDialogCancel,
    enqueueSnackbar,
    setIsEdit,
    setIsShowDialogFailUpdated,
    lincenseKey,
    setLincenseKey,
    isChangeLincenseKey
) => {
    setIsShowDialogCancel(false);
    setIsLoading(true);
    setIsEdit(false);
    const listProvideFunctionUpdated = findDifferenceProvideFunction(
        listProvideFunctionDefaults,
        listProvideFunction
    );

    const listContractInfo = {
        version: selectedVersion
    }

    const listInvidualBasicFunction = {};
    listInvidualBasic?.forEach(item => {
        if (item.label === Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_STORAGE) {
            listInvidualBasicFunction[item.label] = parseFloat(item.value);
        } else {
            listInvidualBasicFunction[item.label] = parseInt(item.value);
        }
    });

    const lincenseKeySettingUpdate = isChangeLincenseKey ? {
        key: lincenseKey.value,
        affiliationOrganization: updator.affiliationOrganization
    } : null;

    const requestDto = {
        id: corporationId,
        updator: updator.id,
        updateMethod: Constant.UPDATE_CORP_DETAIL_METHOD.UPDATE_VIEW_CONTRACT_DETAILS,
        listProvideFunction: JSON.stringify(listProvideFunctionUpdated),
        listContractInfo: JSON.stringify(listContractInfo),
        listInvidualBasicFunction: JSON.stringify(listInvidualBasicFunction),
        limitValue: lincenseKeySettingUpdate ? JSON.stringify(lincenseKeySettingUpdate) : null,
    };
    let result = await organizationService.editCorporations(APIAmplify, requestDto);
    let convertResult = Utils.convertJSONDataToObject(result);
    setIsLoading(false);
    if (convertResult.errorCode) {
        if (convertResult.errorCode === 'MSG_AI_LICENSE_KEY_INVALID') {
            setLincenseKey(prev => ({
                ...prev,
                error: I18n.get('MSG_AI_LICENSE_KEY_INVALID')
            }));
            return;
        }
        return setIsShowDialogFailUpdated(prev => ({...prev, message: convertResult.errorCode, status: true}));
    }
    setTriggerReload(Date.now().toString());
    return enqueueSnackbar(I18n.get('COMMSG045'), {
        variant: 'success',
        autoHideDuration: 3000
    });
};

export const validateInvidualInputs = (val, label) => {

    if (val && label === Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_STORAGE && Utils.checkNumberDecimal(val)) {
        return Utils.checkNumberDecimal(val);
    }

    if (val && !Utils.isNumber(val) && label !== Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING.LABEL_BASIC_STORAGE) {
        return I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace(
            '{{min_value}}',
            `${Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING_VALID.MIN_VALUE}`)
    };

    if (val.length > Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING_VALID.MAX_LENGTH) {
        return I18n.get('MSG-CM-OVER-MAXLENGTH').replace(
            '{{maxLength}}',
            `${Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING_VALID.MAX_LENGTH}`
        );
    }

    return '';
}

export const handleClosePopup = (
    message_code,
    setIsShowDialogFailUpdated, 
    selectedVersion, 
    setSelectedVersion, 
    listVersion, 
    setListVersion
) => {
    if (message_code !== Constant.UPDATED_ROOT_ORG_CODE_FAIL.MSG_VERSION_HAVE_BEEN_DELETED) {
        return window.location.reload();
    }

    const convertVersion = Utils.convertJSONDataToObject(selectedVersion);
    let newListVersion = listVersion.filter(item => item.id !== convertVersion.id);


    setSelectedVersion({});
    setIsShowDialogFailUpdated({status: false, message: ''});
    setListVersion(newListVersion);
}